import { useCallback, useEffect } from "react";
export function useWatchEscapeButton(config) {
    const escFunction = useCallback(event => {
        if (event.key === "Escape") {
            config.when() && config.then();
        }
    }, [config]);
    useEffect(() => {
        document.addEventListener("keydown", escFunction, false);
        return () => {
            document.removeEventListener("keydown", escFunction, false);
        };
    }, [config]);
}
